import { BankAccountsResponse } from '@/types/sso';
import useLanguage from '@/utils/hooks/useLanguage';
import { Fragment } from 'react';

export interface SSIProfileBankDetailsProps {
    ssiProfile: BankAccountsResponse;
}

const SSIProfileBankDetails = (props: SSIProfileBankDetailsProps) => {
    const { ssiProfile } = props;
    const lang = useLanguage();
    return (
        <div className="text-xs text-brand-primary-light flex flex-col gap-5">
            <div>{lang.portal.standardSettlementInstructions}:</div>
            <div className="text-xs text-brand-text">
                <div className="flex flex-col gap-5">
                    <div className="flex flex-col gap-2">
                        <div className="text-brand-neutral-500">{lang.portal.bankDetails}</div>
                        <div className="grid grid-cols-2 gap-2">
                            {ssiProfile.beneficiaryName && (
                                <Fragment>
                                    {ssiProfile.beneficiaryName && (
                                        <>
                                            <div>{lang.portal.beneficiaryName}</div>
                                            <div>{ssiProfile.beneficiaryName}</div>
                                        </>
                                    )}
                                    {ssiProfile.entityAddress && (
                                        <>
                                            <div>{lang.portal.beneficiaryAddress}</div>
                                            <div>{ssiProfile.entityAddress}</div>
                                        </>
                                    )}
                                </Fragment>
                            )}
                            <div>{lang.portal.bankName}</div>
                            <div>{ssiProfile.bankName}</div>
                            {ssiProfile.ibanCode ? (
                                <>
                                    <div>{lang.portal.ibanCode}</div>
                                    <div>{ssiProfile.ibanCode || '-'}</div>
                                </>
                            ) : (
                                <>
                                    <div>{lang.portal.accountNumber}</div>
                                    <div>{ssiProfile.accountNumber || '-'}</div>
                                </>
                            )}

                            <div>{lang.portal.swiftCode}</div>
                            <div>{ssiProfile.swiftCode}</div>
                        </div>
                    </div>
                    {ssiProfile.correspondentBankName && ssiProfile.correspondentBankSwiftCode && (
                        <div className="flex flex-col gap-2">
                            <div className="text-brand-neutral-500">{lang.portal.correspondentBankDetails}</div>
                            <div className="grid grid-cols-2 gap-2">
                                <div>{lang.portal.bankName}</div>
                                <div>{ssiProfile.correspondentBankName}</div>
                                <div>{lang.portal.swiftCode}</div>
                                <div>{ssiProfile.correspondentBankSwiftCode}</div>
                            </div>
                        </div>
                    )}
                    {ssiProfile.intermediaryBankName && ssiProfile.intermediaryBankSwiftCode && (
                        <div className="flex flex-col gap-2">
                            <div className="text-brand-neutral-500">{lang.portal.intermediaryBankDetails}</div>
                            <div className="grid grid-cols-2 gap-2">
                                <div>{lang.portal.bankName}</div>
                                <div>{ssiProfile.intermediaryBankName}</div>
                                <div>{lang.portal.swiftCode}</div>
                                <div>{ssiProfile.intermediaryBankSwiftCode}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="text-xs text-brand-primary-light">
                {lang.portal.pleaseTransferFundsONLYFromWhitelistedBankAccounts}
            </div>
        </div>
    );
};

export default SSIProfileBankDetails;
